<body class="vision-light-theme" (click)="refreshActivityTimer()">
  <app-layout></app-layout>
  <div class="bottom-panel">
    <ng-container *ngIf="(downloads$ | async) as downloads">
      <operation-feedback *ngIf="downloads.length > 0" [items]="downloads" (cancel)="onCancelDownload($event)"
        (close)="onCancelDownloads()" (refresh)="onRetryDownload($event)"></operation-feedback>
    </ng-container>
    <fw-snackbar-container></fw-snackbar-container>
  </div>

  <!-- Agent Chatbox Integration -->
  @if (configService.isAssistantChatEnabled()) {
    <agent-chatbox></agent-chatbox>
  }
</body>
